module.exports = __webpack_public_path__ + "static/media/quiz.fc44a4dc.svg";